import React, { useContext, useState, useRef, useEffect } from "react";
import { Formik } from "formik";
import MultiStepFormContext from "./MultiStepFormContext";
import './JobOnboarding.css';
import axios from "axios";
import { API_BASE_URL } from "../../config";
import './ProfessionDetail.css';

const ProfessionDetail = () =>
{
    const { ProfessionDetails, setProfessionDetails, next } = useContext(MultiStepFormContext);
    const [searchTerm, setSearchTerm] = useState('');
    const [results, setResults] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const MAX_RESULTS = 30;

    const handleSearchChange = async (e) =>
    {
        const searchValue = e.target.value;
        setSearchTerm(searchValue);

        if (searchValue.length > 0)
        {
            try
            {
                const response = await axios.get(`${API_BASE_URL}/api/ProfessionSearch/searchprofessions?search=${searchValue}`);
                console.log("API response:", response.data);
                console.log("Type of response.data:", typeof response.data);
                console.log("Is array?", Array.isArray(response.data));

                setResults(response.data.slice(0, MAX_RESULTS));
                console.log("Setting results:", response.data.slice(0, MAX_RESULTS));

                setDropdownOpen(true);
            } catch (error)
            {
                console.error('Error fetching professions:', error);
            }
        } else
        {
            setResults([]);
            setDropdownOpen(false);
        }
    };

    const handleClear = () =>
    {
        setSearchTerm('');
        setResults([]);
        setDropdownOpen(false);
    };

    useEffect(() =>
    {
        const handleClickOutside = (event) =>
        {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target))
            {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () =>
        {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    return (
        <Formik
            initialValues={{ ...ProfessionDetails }}
            onSubmit={(values) =>
            {
                setProfessionDetails(values);
                next();
            }}
            validate={(values) =>
            {
                const errors = {};
                if (values.profession.length === 0)
                {
                    errors.profession = "At least one profession is required";
                }

                console.log("dropdownOpen:", dropdownOpen);
                console.log("results length:", results.length);
                console.log("searchTerm:", searchTerm);

                return errors;
            }}
        >
            {({ handleSubmit, setFieldValue, values, errors, touched }) => {
                
                console.log("dropdownOpen:", dropdownOpen);
                console.log("results length:", results.length);
                console.log("searchTerm:", searchTerm);
                console.log("values.profession:", values.profession);

                
                return (
                <div>
                    <div className="form-main">
                        <div className="form-row">
                            <div className="form-group">
                                <label>Add profession categories</label>
                                <div className="search-wrapper" >
                                <div className="search-box form-control-wrapper">
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                        placeholder="Profession search"
                                        className="form-control"
                                        onFocus={() => setDropdownOpen(true)}
                                    />
                                    {(results.length > 0 && searchTerm) && (
                                        <button onClick={handleClear} className="clear-button">×</button>
                                    )}
                                </div>
                                {touched.profession && errors.profession && (
                                    <p className="error__feedback">{errors.profession}</p>
                                )}
                                {dropdownOpen && results.length > 0 && (
                                    <ul className="dropdown-results2" ref={dropdownRef}>
                                        {results.map((item, index) => {
                                            console.log("Dropdown item:", item);

                                            return (
                                                <li
                                                key={index}
                                                className="result-item"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  if (!values.profession.some(p => p.id === item.id)) {
                                                    setFieldValue("profession", [...values.profession, { id: item.id, name: item.name }]);
                                                  }
                                                  setSearchTerm("");
                                                  setDropdownOpen(false);
                                                }}
                                              >
                                                <div className="result-item-content">
                                                  <span>{item.name} ({item.type || 'N/A'})</span>
                                                </div>

                                              </li>
                                            );
                                        })}
                                    </ul>
                                )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="selected-items onboarding-selection">
                        {values.profession.length > 0 && (
                            <div className="selected-profession">
                                <label>Selected Professions:</label>
                                <div>
                                    {values.profession.map((profession, index) => (
                                        <div key={index} className="selected-profession-item">
                                            {profession.name}
                                            <button
                                                type="button"
                                                onClick={() =>
                                                {
                                                    setFieldValue("professions", values.profession.filter((p) => p.id !== profession.id));
                                                }}
                                                className="remove-button"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        
                        )}
                    </div>

                    <div className="onboarding-form-button">
                        <button type="button" onClick={handleSubmit} className="next-button">Next</button>
                    </div>
                </div>
                );
            }}
            
        </Formik>
    );
};

export default ProfessionDetail;